import sound1 from "src/Sounds/achive-sound.mp3";
import sound2 from "src/Sounds/electronic-doorbell.mp3";
import sound3 from "src/Sounds/beep.mp3";
import { CryptoIcon } from "src/Common";
import styled from "@emotion/styled";
import { NotificationType } from "../types";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useLocalStorageState from "use-local-storage-state";
import { useAudioPlayer } from "react-use-audio-player";
import { Notification } from "../types/arbitrage";

const alertSoundByType: Record<string, any | null> = {
  [NotificationType.CRITICAL]: sound2,
  [NotificationType.HIGH]: sound1,
  [NotificationType.IMPORTANT]: sound3,
};

export const useProfitAlerts = (alert: Notification | undefined) => {
  const { id, type, crypto } = alert ?? {
    id: "",
    type: { type: "" },
  };
  const [_prevId, _setPrevId] = useLocalStorageState(`profit.cache.alerts.id`);
  const { load, stop } = useAudioPlayer();
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (_prevId !== id && !!id) {
      type?.type &&
        load(alertSoundByType[type.type], {
          autoplay: true,
          loop: false,
          onplay: () => setIsPlaying(true),
        });
      _setPrevId(id);
      toast(<ToastComponent crypto={crypto} type={type.type} profit={alert?.profit} minExchange={alert?.minExchange} maxExchange={alert?.maxExchange} />, {
        theme: "dark",
        autoClose: 8000,
        pauseOnFocusLoss: false,
      });
    }
  }, [id, _prevId, type.type, crypto, _setPrevId, setIsPlaying, load]);

  useEffect(() => {
    if (isPlaying) {
      const timer = setTimeout(() => {
        stop();
        setIsPlaying(false);
      }, type.milliseconds ?? 20000);
      return () => clearTimeout(timer);
    }
  }, [isPlaying, stop, type.milliseconds]);

  return {};
};

const ToastComponent = ({
  crypto,
  type,
  profit,
  minExchange,
  maxExchange,
}: {
  crypto?: Notification["crypto"];
  type: string;
  profit?: number;
  minExchange?: string;
  maxExchange?: string;
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Title>{type}:</Title>
      <ContainerFlex style={{ margin: "0.5rem 0" }}>
        <CryptoIcon slug={crypto?.slug ?? ""} style={{ height: "1.5rem" }} />
        <Symbol>{crypto?.symbol}</Symbol>
      </ContainerFlex>
      {profit != null && (
        <div style={{ fontSize: "0.85rem", color: "#4caf50", fontWeight: 600 }}>
          ${profit.toFixed(2)}
        </div>
      )}
      {minExchange && maxExchange && (
        <div style={{ fontSize: "0.8rem", color: "#aaa" }}>
          {minExchange} → {maxExchange}
        </div>
      )}
    </div>
  );
};

const ContainerFlex = styled.div({
  display: "flex",
  alignItems: "center",
});

const Title = styled.h3({
  fontWeight: 600,
});

const Symbol = styled.div({
  padding: "0 0.5rem",
  fontWeight: 600,
  fontSize: "0.9rem",
});
